export default __webpack_public_path__ + "static/media/barbarian.17ad0231.jpeg";